import { render } from "./ModalErrorsMessage.vue?vue&type=template&id=c5224ea6&scoped=true"
import script from "./ModalErrorsMessage.vue?vue&type=script&lang=js"
export * from "./ModalErrorsMessage.vue?vue&type=script&lang=js"

import "./ModalErrorsMessage.vue?vue&type=style&index=0&id=c5224ea6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5224ea6"]])

export default __exports__